import React from 'react';
import cn from 'classnames';

var styles = {"component":"loader__component_1076g","blink":"loader__blink_1076g"};
require('./index.css');

var Loader = function (_a) {
    var className = _a.className, dataTestId = _a.dataTestId;
    return (React.createElement("svg", { height: '24', width: '24', viewBox: '0 0 24 24', className: cn(styles.component, className), "data-test-id": dataTestId },
        React.createElement("circle", { cx: '4', cy: '12', r: '2' }),
        React.createElement("circle", { cx: '12', cy: '12', r: '2' }),
        React.createElement("circle", { cx: '20', cy: '12', r: '2' })));
};

export { Loader };
